import { ReactElement, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './MobileNavigation.module.scss'
import {
  FacebookIconImage,
  FightbackLogoImage,
  InstagramIconImage,
  WhatsAppIconImage,
  YoutubeIconImage,
} from '../icon/Icon'
import { MAIN_ROUTES, NavigationItems } from '../../config/navigationItems'
import { HAMBURGER_FOLDING_DURATION, HamburgerMenu } from '../hamburger-menu/HamburgerMenu'
import { VelocityComponent } from 'velocity-react'
import { MobileHeadlineLarge } from '../../Typography'
import { URLS } from '../../content/urls'
import { ROUTES } from '../../config/routes'

export const MobileNavigation = (): ReactElement => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isActive, setIsActive] = useState(false)

  const toggleIsActive = (): void => {
    setIsActive(!isActive)
  }
  return (
    <div>
      <header
        className={location.pathname === ROUTES.start ? styles.header : styles.headerWithBackground}
      >
        <div className={styles.logoBox} onClick={(): void => navigate(ROUTES.start)}>
          {FightbackLogoImage}
        </div>
        <HamburgerMenu isActive={isActive} onClick={toggleIsActive} />
      </header>
      <VelocityComponent
        animation={{ translateX: isActive ? 0 : '100vw' }}
        duration={300}
        delay={isActive ? HAMBURGER_FOLDING_DURATION : 0}
        easing={'swing'}
      >
        <div className={styles.slidingMenu}>
          <div className={styles.navItemBox}>
            {NavigationItems.map((item): ReactElement => {
              const isCurrentScreen =
                item.route === ROUTES.start
                  ? !MAIN_ROUTES.some((route) => location.pathname.startsWith(route))
                  : location.pathname === item.route ||
                    location.pathname.startsWith(item.route + '/')

              return (
                <MobileHeadlineLarge
                  className={styles.navItem}
                  opacity={isCurrentScreen ? 1 : 0.25}
                  key={item.name}
                  onClick={(): void => {
                    toggleIsActive()
                    navigate(item.route)
                  }}
                >
                  {item.name}
                </MobileHeadlineLarge>
              )
            })}
            <div className={styles.navIconBox}>
              <a href={URLS.youtube} target='_blank' rel='noreferrer'>
                {YoutubeIconImage}
              </a>
              <a href={URLS.facebook} target='_blank' rel='noreferrer'>
                {FacebookIconImage}
              </a>
              <a href={URLS.instagram} target='_blank' rel='noreferrer'>
                {InstagramIconImage}
              </a>
              <a href={URLS.whatsapp} target='_blank' rel='noreferrer'>
                {WhatsAppIconImage}
              </a>
            </div>
          </div>
        </div>
      </VelocityComponent>
    </div>
  )
}
